import React from "react";

import PropTypes from "prop-types";

import "./bola-nmero-ativa.css";

const BolaNmeroAtiva = (props) => {
  return (
    <div className={`bola-nmero-ativa-container ${props.rootClassName} `}>
      <img
        alt="image"
        src="/lp/economiadacooperacao/Secao3/bolinha%20ativa-300h.png"
        className="bola-nmero-ativa-image"
      />
      <span className="bola-nmero-ativa-text Exo2-H3">{props.numero}</span>
    </div>
  );
};

BolaNmeroAtiva.defaultProps = {
  numero: "1",
  rootClassName: "",
};

BolaNmeroAtiva.propTypes = {
  numero: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default BolaNmeroAtiva;
